var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('domains-switcher'),_c('div',{staticClass:"header__venue"},[_c('div',{staticClass:"header__venue__name mb-8"},[_vm._v(" "+_vm._s(_vm.venueInfo.name)+" ")]),_c('div',[_vm._v("Events")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }